import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import { formatCurrency } from '@/helpers/formatters';

type PriceTableProps = {
  basePrice: number;
  downPayment: number;
  estimatedFees: number;
  conditionAmount: number;
  tradeInEquityAmount?: number;
  finalVehicleFinancePrice: number;
};

const PriceTable = ({
  basePrice,
  downPayment,
  estimatedFees,
  conditionAmount,
  tradeInEquityAmount,
  finalVehicleFinancePrice,
}: PriceTableProps) => {
  const formattedFees = formatCurrency(estimatedFees);
  const formattedVehiclePrice = formatCurrency(basePrice);
  const formattedFinalPrice = formatCurrency(finalVehicleFinancePrice);
  const formattedDownPayment = formatCurrency(downPayment + conditionAmount);
  const formattedTradeInEquity = tradeInEquityAmount
    ? formatCurrency(tradeInEquityAmount)
    : undefined;

  return (
    <>
      <Typography variant="h6"> Cost Breakdown </Typography>

      <Table size="small" className="fbs-terms-price-table">
        <TableBody>
          <TableRow>
            <TableCell>Vehicle price</TableCell>
            <TableCell
              align="right"
              aria-describedby="vehicle-price-disclaimer"
            >
              {formattedVehiclePrice}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Est. tax, title &#38; fees</TableCell>
            <TableCell align="right">{formattedFees}</TableCell>
          </TableRow>

          {formattedTradeInEquity && (
            <TableRow>
              <TableCell>Trade-in equity</TableCell>
              <TableCell align="right">{formattedTradeInEquity}</TableCell>
            </TableRow>
          )}

          <TableRow>
            <TableCell>Down payment</TableCell>
            <TableCell align="right">- {formattedDownPayment}</TableCell>
          </TableRow>

          <TableRow className="price-table-final">
            <TableCell>
              <Typography variant="subtitle1" component="span">
                Total finance amount
              </Typography>
            </TableCell>

            <TableCell align="right">
              <Typography variant="subtitle1" component="span">
                {formattedFinalPrice}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

export default PriceTable;
